import Loadable from 'react-loadable';

import { DropdownItem } from '@atlaskit/dropdown-menu';
import Spinner from '@atlaskit/spinner';

import { ForgeRepoCodeOverviewActionAppsListProps } from './repo-code-overview-action-apps-list';

const LoadableDropdownAppList = Loadable({
  loading: () => (
    <DropdownItem>
      <Spinner size="small" />
    </DropdownItem>
  ),
  loader: () => import('./repo-code-overview-action-apps-list'),
});

export const preloadLoadableDropdownAppList = () => {
  LoadableDropdownAppList.preload();
};

export const LazyForgeRepoCodeOverviewActionAppsList = (
  props: Omit<
    ForgeRepoCodeOverviewActionAppsListProps,
    'currentUser' | 'repository'
  >
) => {
  return <LoadableDropdownAppList {...props} />;
};
